module.exports = __webpack_public_path__ + "img/download-googleplay.2a016f46.png";